
















import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    title: { type: String, required: true },
    text: { type: [String, Boolean], default: false },
    ok: { type: String, required: true },
    cancel: { type: String, required: true },
    clickOk: { type: Function as PropType<() => void>, required: true },
    clickCancel: { type: Function as PropType<() => void>, required: true },
    loading: { type: Boolean, required: true },
  },
});
